import { useClientTimeZone } from '@/hooks/useClientTimeZone';
import useTranslation from '@/hooks/useTranslation';
import { DateTimeFormat, sanitizeIcu } from '@/utils/dateUtils';
import type { FCl } from 'react-fc';

interface IProps {
    time: string; // ISO8601
}

export const LocalizedTime: FCl<IProps> = ({ className, time }) => {
    const { lang } = useTranslation();
    const timeZone = useClientTimeZone();
    const date = new Date(time);

    return (
        <time className={className} dateTime={date.toISOString()}>
            {sanitizeIcu(
                DateTimeFormat(lang, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZoneName: 'short',
                    timeZone,
                }).format(date)
            )}
        </time>
    );
};
